import moment from 'moment';
import propTypes from 'prop-types';
import { React, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { connect } from 'react-redux';
import { getMyBooking } from '../../actions/booking';
import { checkout, getKey } from '../../actions/payment';
import { getRooms } from '../../actions/room';

const PaymentMain = ({ auth: { user, isAuthenticated}, payment, booking: {bookings}, checkout, getKey, getMyBooking, getRooms, room: {rooms}}) => {

    useEffect(() => {
        getMyBooking()
    }, [getMyBooking])

    useEffect(() => {
        getRooms()
    }, [getRooms])

    useEffect(()=>{
        getKey();
    },[getKey]);

    useEffect(()=>{
        checkout(amount); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkout]);

    const currURL = window.location.href;
    const splitURL= currURL.toString().split("/");
    let n = splitURL.length;
    const amount = splitURL[n-1];
    const bookingid = splitURL[n-2];
    const booking = bookings.find(b => b._id === bookingid);

    const checkoutHandler = async (amount) => {
        const key = payment.key;
        const order = payment.order.order;
        const bookingid = splitURL[n-2];
        //const { data: { order } } = await axios.post("http://localhost:5000/api/payments/checkout", {amount});
    
        const options = {
            key,
            order_id: order.id,
            amount: order.amount,
            currency: "INR",
            name: "GharBar",
            description: "Hotel Booking Charges",
            image: "https://avatars.githubusercontent.com/u/77050199?v=4",
            callback_url: `https://gharbar-backend.onrender.com/api/payments/verifypayment/${bookingid}/${amount}`,
            //callback_url: `/studentDashboard/payments/verifyPayment/${applicationid}/${amount}`,
            notes: {
                "address": "DTU, Shahbad, Daulatpur, New Delhi"
            },
            theme: {
                "color": "#9edb02"
            }
        };
        const razor = new window.Razorpay(options);
        razor.open();
    }

  return (
    <div className='container' style={{ maxWidth: '600px'}}>
        {isAuthenticated && user && user.usertype === 'guest' && (
            <Card border='success'>
                <Card.Body>
                    <Col style={{padding: '10px'}}>
                    {rooms.map(room => room._id === booking.roomid && 
                    <>
                        <Row><img src={room.imageurl[0]} alt = 'room img' /></Row>
                        <Row><Col>Room: {room.roomno}</Col><Col style={{textAlign: 'right'}}>Type: {room.roomtype}</Col></Row>
                    </>
                    )}
                    </Col>
                    <Col style={{padding: '10px'}}>
                        <h6>Booking Details</h6>
                        <Row><Col>Guest Name</Col><Col>{booking.name}</Col></Row>
                        <Row><Col>Mobile</Col><Col>{booking.mobile}</Col></Row>
                        <Row><Col>Duration</Col><Col>{booking.totaldays}{' '}Days</Col></Row>
                        <Row><Col>Check-In Date</Col><Col>{moment(booking.datefrom, 'DD-MM-YYYY').format('DD MMM YYYY')}</Col></Row>
                        <Row><Col>Check-Out Date</Col><Col>{moment(booking.dateto, 'DD-MM-YYYY').format('DD MMM YYYY')}</Col></Row>
                        <Row><Col>Coupon</Col><Col>{booking.couponcode && <>{booking.couponcode}</>} {!booking.couponcode && <>Not Applied</>}</Col></Row>
                        <Row><Col>Amount</Col><Col><b><i className='fa fa-indian-rupee'></i>&nbsp;{booking.totalamount}</b></Col></Row>
                    </Col>
                    
                </Card.Body>
                <Card.Footer>
                    <center>
                        <div className='btn btn-success' onClick={() => checkoutHandler(amount)}>
                            Confirm & Pay
                        </div>
                    </center>
                </Card.Footer>
            </Card>
        )}
    </div>
  )
}

PaymentMain.propTypes = {
    auth: propTypes.object.isRequired,
    payment: propTypes.object.isRequired,
    getKey: propTypes.func.isRequired,
    checkout: propTypes.func.isRequired,
    booking: propTypes.object.isRequired,
    getMyBooking: propTypes.func.isRequired,
    getRooms: propTypes.func.isRequired
  };
  

const mapStateToProps = (state) => ({
    auth: state.auth,
    payment: state.payment,
    booking: state.booking,
    room: state.room
});

export default connect(mapStateToProps, {getKey, checkout, getMyBooking, getRooms})(PaymentMain);